import { render, staticRenderFns } from "./grup78.vue?vue&type=template&id=13516e0a&scoped=true&"
import script from "./grup78.vue?vue&type=script&lang=js&"
export * from "./grup78.vue?vue&type=script&lang=js&"
import style0 from "./grup78.vue?vue&type=style&index=0&id=13516e0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13516e0a",
  null
  
)

export default component.exports